export const backgroundPalette = {
  alto: {
    20: "#F9F8F4",
  },
} as const;

type BackgroundAlto = `background.alto.${keyof typeof backgroundPalette.alto}`;

export type BackgroundPalette = BackgroundAlto;
